import { handleSystemErrorReport } from '@mb/lib/utils';
import { StatusEnum as SnackbarStatusEnum } from 'components/components/MBSnackbar';
import { config } from '../../config';
import { DefaultSnackbarMessage } from '../../constants/notification';
import { setSnackbarInfo } from '../../redux/sliceCreators/commonSlice';
import { AppDispatch } from '../../redux/store'; // Adjust the import path as needed
import { ResponseStatusEnum } from '../../types';
import { client } from '../http';

export const exportToCSV =
  (productIds?: string[]) => async (dispatch: AppDispatch) => {
    try {
      const { data } = await client.get(
        `${config.endpoints.exportToCSV}${
          productIds != null && productIds.length ? `/${productIds.join()}` : ''
        }`,
      );
      if (data.status === ResponseStatusEnum.FAILED) {
        dispatch(
          setSnackbarInfo({
            isOpen: true,
            status: SnackbarStatusEnum.DANGER,
            message:
              data?.message ?? DefaultSnackbarMessage.SOMETHING_WENT_WRONG,
          }),
        );
        return;
      }
      const url = new URL(data.file_ur_l);

      window.open(
        `${window.origin}${url.href.replace(url.origin, '')}`,
        '_blank',
      );
    } catch (error) {
      console.log('Error exportToCSV:', error);
      dispatch(
        setSnackbarInfo({
          isOpen: true,
          status: SnackbarStatusEnum.DANGER,
          message:
            error?.message ?? DefaultSnackbarMessage.SOMETHING_WENT_WRONG,
        }),
      );
      handleSystemErrorReport(
        `Error exportToCSV: ${
          error?.message ?? DefaultSnackbarMessage.SOMETHING_WENT_WRONG
        }`,
        'exportToCSV',
      );
    }
  };

export const exportToPDF =
  (productIds: string[]) => async (dispatch: AppDispatch) => {
    try {
      const { data } = await client.get(
        config.endpoints.exportToPDF(productIds, 'materials'),
      );
      if (data.status === ResponseStatusEnum.FAILED) {
        console.log('Error exportToPDF:', data);

        dispatch(
          setSnackbarInfo({
            isOpen: true,
            status: SnackbarStatusEnum.DANGER,
            message:
              data?.message ?? DefaultSnackbarMessage.SOMETHING_WENT_WRONG,
          }),
        );
        return;
      }
      window.open(data.zip_file_url, '_blank');
    } catch (error) {
      console.log('Error exportToPDF:', error);
      dispatch(
        setSnackbarInfo({
          isOpen: true,
          status: SnackbarStatusEnum.DANGER,
          message:
            error?.message ?? DefaultSnackbarMessage.SOMETHING_WENT_WRONG,
        }),
      );
      handleSystemErrorReport(
        `Error exportToPDF: ${
          error?.message ?? DefaultSnackbarMessage.SOMETHING_WENT_WRONG
        }`,
        'exportToPDF',
      );
    }
  };
